type ApiErrorPrefix = {
  label: string
  value?: string | null
}

export const formatUpdateDecisionApiError = (
  error?: string | null,
  prefix?: ApiErrorPrefix
): string | undefined => {
  const trimmed = error?.trim()
  if (!trimmed) return undefined

  const productsToken = 'Products:'
  const tokenIndex = trimmed.indexOf(productsToken)
  if (tokenIndex < 0) return trimmed

  const ruleMessage = trimmed.slice(0, tokenIndex).trim()
  if (!ruleMessage) return trimmed

  const normalizedRuleMessage = ruleMessage.endsWith('.') ? ruleMessage : `${ruleMessage}.`

  if (prefix) {
    const normalizedPrefixValue = prefix.value?.trim()
    if (!normalizedPrefixValue) return normalizedRuleMessage
    return `${prefix.label}: ${normalizedPrefixValue} - ${normalizedRuleMessage}`
  }

  const products = trimmed.slice(tokenIndex + productsToken.length).trim()
  if (!products) return trimmed

  return `Products: ${products} - ${normalizedRuleMessage}`
}
